import axios from "axios";
const REACT_APP_ADMIN_API = process.env.REACT_APP_ADMIN_API;
const { CancelToken } = axios;
const source = CancelToken.source();

export const cancelFsm = async (imeis: string[]) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  const region = localStorage.getItem("region");
  try {
    const response = await axios({
      method: "post",
      url: `${REACT_APP_ADMIN_API}/api/fsm/cancel`,
      headers: { Authorization: `Bearer ${token}` },
      data: {
        imeis: imeis,
      }
    });
    return { data: response.data };
  } catch (e) {
    return e;
  }
};

export const resetFsm = async (imeis: string[], force: boolean) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  const region = localStorage.getItem("region");
  try {
    const response = await axios({
      method: "post",
      url: `${REACT_APP_ADMIN_API}/api/fsm/reset`,
      headers: { Authorization: `Bearer ${token}` },
      data: {
        imeis: imeis,
        force: force,
      }
    });
    return { data: response.data };
  } catch (e) {
    return e;
  }
};
